module.exports = __webpack_public_path__ + "static/img/18.5df4038.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/18.gif
// module id = g6x2
// module chunks = 0